<template>
    <div id="NewsDetail" :class="{'page-loaded': pageLoaded}">
        <!-- 顶部Banner区域 -->
        <div class="news-banner animate-element">
            <div class="banner-content">
                <h1 class="animate-element">新闻详情</h1>
                <p class="animate-element">{{ newsData ? newsData.title : '加载中...' }}</p>
            </div>
        </div>
        
        <!-- 主内容区域，使用固定宽度并居中 -->
        <div class="main-content">
            <div class="news-detail-container animate-element">
                <!-- 面包屑导航 -->
                <div class="breadcrumb">
                    <span @click="goToNewsList">新闻动态</span>
                    <i class="glyphicon glyphicon-chevron-right"></i>   
                    <span  @click="goToNewsList">{{ getCategoryName }}</span>
                    <i class="glyphicon glyphicon-chevron-right"></i>
                    <span class="current">详情</span>
                </div>
                
                <!-- 新闻内容区域 -->
                <div class="news-content-wrap" v-if="newsData">
                    <h1 class="news-title">{{ newsData.title }}</h1>
                    <div class="news-meta">
                        <span class="news-date">
                            <i class="glyphicon glyphicon-calendar"></i>
                            {{ newsData.year }}-{{ newsData.date }}
                        </span>
                        <span class="news-category">
                            <i class="glyphicon glyphicon-folder-open"></i>
                            {{ getCategoryName }}
                        </span>
                    </div>
                    
                    <div class="news-image" v-if="newsImage">
                        <img :src="newsImage" alt="新闻图片">
                    </div>
                    
                    <div class="news-content">
                        <p class="news-intro">{{ newsData.introduce }}</p>
                        <!-- 更多内容段落 -->
                        <p v-for="(paragraph, index) in generateContent()" :key="index">
                            {{ paragraph }}
                        </p>
                    </div>
                </div>
                
                <!-- 加载中状态 -->
                <div class="loading-state" v-else>
                    <i class="glyphicon glyphicon-refresh"></i>
                    <p>加载中...</p>
                </div>
                
                <!-- 返回按钮 -->
                <div class="back-button-container">
                    <button class="back-button" @click="goToNewsList">
                        <i class="glyphicon glyphicon-arrow-left"></i> 返回新闻列表
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsDetail',
    data() {
        return {
            pageLoaded: false,
            newsImage: null,
            newsCategories: {
                company: [
                    {
                        id: '001',
                        title: '公司荣获2023年度科技创新企业称号',
                        introduce: '我司凭借在技术研发领域的突出贡献，被评为2023年度科技创新示范企业，这是对公司长期以来专注技术创新的充分肯定。',
                        date: '05-24',
                        year: '2023',
                        image: ''
                    },
                    {
                        id: '002',
                        title: '公司成功举办年度技术开放日活动',
                        introduce: '公司于上月成功举办了年度技术开放日活动，向合作伙伴展示了最新的技术成果和产品路线图，获得了广泛好评。',
                        date: '04-15',
                        year: '2023',
                        image: ''
                    },
                    {
                        id: '003',
                        title: '公司与某知名高校达成战略合作',
                        introduce: '我公司与国内著名高校签署了战略合作协议，双方将在技术研发、人才培养等方面展开深度合作，共同推动行业发展。',
                        date: '03-08',
                        year: '2023',
                        image: ''
                    },
                    {
                        id: '004',
                        title: '公司新一代产品成功发布',
                        introduce: '公司举行了新产品发布会，全新一代解决方案获得了客户和行业专家的高度评价，预计将在下季度正式投入市场。',
                        date: '02-20',
                        year: '2023',
                        image: ''
                    },
                    {
                        id: '005',
                        title: '公司获评年度最佳雇主',
                        introduce: '公司凭借优质的企业文化和员工关怀计划，在年度评选中获得"最佳雇主"称号，彰显了公司在人才培养方面的卓越成就。',
                        date: '01-15',
                        year: '2023',
                        image: ''
                    },
                    {
                        id: '006',
                        title: '公司董事长参加行业高峰论坛',
                        introduce: '公司董事长受邀参加了全国行业高峰论坛，并发表了关于行业未来发展趋势的重要演讲，引起广泛关注。',
                        date: '12-28',
                        year: '2022',
                        image: ''
                    },
                    {
                        id: '007',
                        title: '公司董事长参加行业高峰论坛',
                        introduce: '公司董事长受邀参加了全国行业高峰论坛，并发表了关于行业未来发展趋势的重要演讲，引起广泛关注。',
                        date: '12-28',
                        year: '2022',
                        image: ''
                    }
                ],
                industry: [
                    {
                        id: '101',
                        title: '行业数字化转型进程加速',
                        introduce: '据最新行业报告显示，我国企业数字化转型正在加速推进，超过60%的企业已经开始或计划实施数字化转型策略。',
                        date: '05-18',
                        year: '2023',
                        image: ''
                    },
                    {
                        id: '102',
                        title: '新一代通信技术标准正式发布',
                        introduce: '国际通信标准组织正式发布新一代通信技术标准，这将为全行业带来新的发展机遇，推动通信技术迈向新台阶。',
                        date: '04-30',
                        year: '2023',
                        image: ''
                    },
                    {
                        id: '103',
                        title: '人工智能在企业应用中取得突破',
                        introduce: '人工智能技术在企业应用领域取得重大突破，智能客服、智能分析等应用场景已经成为企业提升效率的重要手段。',
                        date: '03-25',
                        year: '2023',
                        image: ''
                    },
                    {
                        id: '104',
                        title: '全球芯片供应链问题逐步缓解',
                        introduce: '经过两年的紧张局势，全球芯片供应链问题正在逐步缓解，多家芯片制造商已经宣布扩大产能计划。',
                        date: '02-10',
                        year: '2023',
                        image: ''
                    }
                ]
            }
        }
    },
    computed: {
        newsId() {
            return this.$route.params.id;
        },
        category() {
            return this.$route.params.category;
        },
        newsData() {
            const categoryList = this.newsCategories[this.category] || [];
            return categoryList.find(item => item.id === this.newsId) || null;
        },
        getCategoryName() {
            return this.category === 'company' ? '公司新闻' : '行业动态';
        }
    },
    methods: {
        goToNewsList() {
            this.$router.push('/newsinformation');
        },
        initPageAnimation() {
            setTimeout(() => {
                this.pageLoaded = true;
            }, 100);
        },
        getDefaultImage(index) {
            // 默认图片集合，可以根据需要添加更多
            const images = [
                require('../assets/img/banner_1.jpg'),
                require('../assets/img/banner_2.jpg'),
                require('../assets/img/banner1.png'),
                require('../assets/img/banner2.jpg'),
                require('../assets/img/2020123019370372.jpg'),
                require('../assets/img/2020123019390333.jpg')
            ];
            return images[index % images.length];
        },
        generateContent() {
            // 根据新闻ID生成一些模拟内容段落
            const paragraphs = [];
            const baseText = "这是新闻详情内容的扩展段落。在这里，我们可以提供更详细的信息和背景。";
            const variations = [
                "这一发展对行业产生了深远影响，专家预测未来几年内相关领域将持续高速增长。",
                "公司表示，将继续加大研发投入，推动技术革新，为客户提供更优质的产品和服务。",
                "据了解，多家企业已经开始采用类似技术，市场竞争将进一步加剧。",
                "此举获得了行业专家的高度评价，被认为是推动行业发展的重要举措。",
                "未来，公司将继续关注行业发展趋势，不断调整战略方向，保持市场竞争力。"
            ];
            
            // 添加基础段落
            paragraphs.push(baseText);
            
            // 根据ID生成2-4个额外段落
            const idNum = parseInt(this.newsId.replace(/[^\d]/g, ''), 10);
            const paragraphCount = 2 + (idNum % 3); // 2-4个段落
            
            for (let i = 0; i < paragraphCount; i++) {
                paragraphs.push(variations[i % variations.length]);
            }
            
            return paragraphs;
        }
    },
    mounted() {
        // 页面挂载完成后进行初始化
        this.initPageAnimation();
        
        // 设置新闻图片
        if (this.newsData) {
            // 如果有图片，使用自带图片，否则使用默认图片
            this.newsImage = this.newsData.image || this.getDefaultImage(parseInt(this.newsId.replace(/[^\d]/g, ''), 10));
        }
        
        // 设置页面标题
        document.title = this.newsData ? `${this.newsData.title} - 新闻详情` : '新闻详情';
    }
}
</script>

<style scoped>
/* 全局样式 */
#NewsDetail {
    font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: #333;
    overflow-x: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    min-height: 100vh;
}

/* 页面加载状态类 */
.page-loaded .animate-element {
    opacity: 1;
    transform: translateY(0);
}

/* 动画元素基础样式 */
.animate-element {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease, transform 0.6s ease;
}

/* 主内容区域 - 固定宽度并居中 */
.main-content {
    width: 85%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
}

/* Banner区域 - 全宽但内容居中 */
.news-banner {
    height: 250px;
    background-image: linear-gradient(to right, rgba(30, 115, 190, 0.8), rgba(0, 0, 0, 0.6)), url('../assets/img/banner_1.jpg');
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-bottom: 50px;
    position: relative;
    width: 100%;
    transition-delay: 0s;
}

.banner-content {
    text-align: center;
    z-index: 2;
    width: 85%;
    max-width: 1200px;
}

.banner-content h1 {
    font-size: 42px;
    font-weight: 600;
    margin-bottom: 15px;
    letter-spacing: 2px;
    transition-delay: 0.2s;
}

.banner-content p {
    font-size: 18px;
    opacity: 0.9;
    max-width: 800px;
    margin: 0 auto;
    transition-delay: 0.3s;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 新闻详情容器 */
.news-detail-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    padding: 40px;
    margin-bottom: 60px;
    transition-delay: 0.4s;
}

/* 面包屑导航 */
.breadcrumb {
    margin-bottom: 30px;
    color: #666;
    font-size: 14px;
}

.breadcrumb span {
    display: inline-block;
    margin: 0 5px;
}

.breadcrumb span:not(.current) {
    color: #1e73be;
    cursor: pointer;
    transition: color 0.2s ease;
}

.breadcrumb span:not(.current):hover {
    color: #155892;
    text-decoration: underline;
}

.breadcrumb i {
    font-size: 10px;
    color: #999;
}

.breadcrumb .current {
    color: #333;
    font-weight: 500;
}

/* 新闻内容样式 */
.news-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 20px;
    line-height: 1.4;
    color: #222;
}

.news-meta {
    margin-bottom: 25px;
    color: #777;
    font-size: 14px;
    display: flex;
    align-items: center;
}

.news-meta span {
    margin-right: 20px;
    display: flex;
    align-items: center;
}

.news-meta i {
    margin-right: 5px;
}

.news-image {
    margin-bottom: 30px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.news-image img {
    width: 100%;
    display: block;
}

.news-content {
    line-height: 1.8;
    color: #444;
}

.news-content p {
    margin-bottom: 20px;
}

.news-intro {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

/* 加载状态 */
.loading-state {
    text-align: center;
    padding: 60px 0;
    color: #888;
}

.loading-state i {
    font-size: 40px;
    margin-bottom: 15px;
    display: block;
    animation: spin 1s infinite linear;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.loading-state p {
    font-size: 16px;
}

/* 返回按钮 */
.back-button-container {
    margin-top: 40px;
    text-align: center;
}

.back-button {
    padding: 12px 25px;
    background: #1e73be;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
}

.back-button:hover {
    background: #155892;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(30, 115, 190, 0.3);
}

.back-button i {
    margin-right: 8px;
}

/* 响应式设计 */
@media screen and (max-width: 767px) {
    .main-content {
        width: 95%;
        padding: 0 10px;
    }
    
    .banner-content {
        width: 95%;
    }

    .news-banner {
        height: 180px;
    }
    
    .banner-content h1 {
        font-size: 28px;
    }
    
    .banner-content p {
        font-size: 14px;
    }
    
    .news-detail-container {
        padding: 20px;
    }
    
    .news-title {
        font-size: 22px;
    }
}
</style> 


// WEBPACK FOOTER //
// src/view/NewsDetail.vue